/** Matches the Figma `Mode` property and the legacy ticket types. */
export type BetslipMode = 'single' | 'combi' | 'system';

export const BETSLIP_MODES: { value: BetslipMode; label: string }[] = [
  { value: 'single', label: 'Single' },
  { value: 'combi', label: 'Combi' },
  { value: 'system', label: 'System' },
];
